<template>
  <div class="featuredItem">
    <div class="banner-wrapper">
      <img src="../assets/featured/banner.png" alt="" class="banner">
    </div>
    <div class="data-count">
      <ul class="data-ul flex-align-between">
        <li class="data-li">
          <p class="data-li-value animate__animated animate__bounce">1000+</p>
          <h5 class="data-li-name">共建区域</h5>
        </li>
        <li class="data-li">
          <p class="data-li-value">20000+</p>
          <h5 class="data-li-name">参训人数</h5>
        </li>
        <li class="data-li">
          <p class="data-li-value">3000+</p>
          <h5 class="data-li-name">课程</h5>
        </li>
      </ul>
    </div>
    <div class="table-wrapper">
      <div class="sort flex-layout">
        <span class="sort-name">院系：</span>
        <ul class="sort-ul">
          <li v-for="(item,index) in sortList" :key="index" :class="{'active':sortSelected === item.id}" class="csp"
            @click="changeSort(item,index)">
            {{item.name}}
          </li>
        </ul>
      </div>
      <div class="table">
        <h3 class="table-title">小学各学科骨干教师研修服务项目</h3>
        <el-table :data="tableData" style="width: 100%" stripe>
          <el-table-column prop="date" label="项目名称" align="center" width="300">
          </el-table-column>
          <el-table-column prop="name" label="项目内容" align="center">
            <template slot-scope="scope">
              <p style="text-align:left;">{{scope.row.name}}</p>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        sortSelected: 1,
        sortList: [{
            id: 1,
            name: '初等教育学院'
          },
          {
            id: 2,
            name: '教师教育学院'
          },
          {
            id: 3,
            name: '心理学院'
          },
          {
            id: 4,
            name: '京疆学院'
          }
        ],
        tableData: [{
          date: '2016-05-02',
          name: '学院教育教研室设有少年儿童组织与思想意识教育专业，从事少先队辅导员高级人才培养，促进少先队辅导员职业化、专业化发展。擅长从少先队工作发展需要、辅导员专业发展、学校少先队工作实际等方面，进行科学系统的在职少先队辅导员培训与研修工作。',
        }, {
          date: '2016-05-04',
          name: '王小虎',
        }, {
          date: '2016-05-01',
          name: '王小虎',
        }, {
          date: '2016-05-03',
          name: '王小虎',
        }]
      }
    },
    methods: {
      changeSort(item, index) {
        this.sortSelected = item.id;
      },
    }
  }
</script>

<style scoped lang="less">
  .featuredItem {
    padding-bottom: 200px;

    .banner {
      width: 100%;
      display: block;
    }

    .data-count {
      box-shadow: 0px 4px 17px 0px rgba(0, 0, 0, 0.03);
      margin-bottom: 50px;


      .data-ul {
        width: 1200px;
        margin: 0 auto;
        padding: 36px 121px 40px 121px;
        box-sizing: border-box;
        text-align: center;
      }

      .data-li {
        width: calc(100% / 3);

        &:nth-child(2) {
          border-left: 1px solid #e8e8e8;
          border-right: 1px solid #e8e8e8;
        }
      }

      .data-li-value {
        font-size: 42px;
        margin-bottom: 20px;
      }

      .data-li-name {
        font-size: 24px;
        font-weight: 300;
      }
    }

    .table-wrapper {
      width: 1200px;
      margin: 0 auto;

      .sort {
        background-color: #fff;
        border-radius: 10px;
        line-height: 59px;
        margin-bottom: 40px;
        padding: 0 15px 0 34px;
        box-shadow: 0px 0px 3px 0px rgba(127, 127, 127, 0.14);

        .sort-name {
          font-size: 16px;
          color: #555555;
          width: 66px;
        }

        .sort-ul {
          li {
            font-size: 16px;
            display: inline-block;
            padding: 0 28px;
            color: #999;
          }

          li.active {
            color: #fff;
            background-color: rgba(80, 142, 249, 1);
          }
        }
      }

      .table {
        margin-bottom: 43px;
      }

      .table-title {
        text-align: center;
        margin-bottom: 40px;
        font-size: 32px;
        position: relative;
        padding: 54px 0;
        z-index: 2;
      }

      .table-title::after {
        content: ' ';
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        display: inline-block;
        width: 107px;
        height: 131px;
        color: #383838;
        background-image: url("../assets/common/title-bg.png");
        background-repeat: no-repeat;
        background-size: 100%;
        z-index: -1;
      }

      /deep/ .el-table {
        border-radius: 8px;
        border: 1px solid #F6F6F6;
      }

      /deep/ .el-table__header {
        thead th {
          color: #000;
          font-weight: 400;
          background-color: RGBA(250, 251, 255, 1);
          border: 0;
        }
      }

      /deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
        background: #FAFBFF;
      }

      /deep/.el-table td, .el-table th.is-leaf {
        border-bottom: 1px solid #F6F6F6;
      }
    }





    @media screen and (max-width: 1250px) {
      padding-bottom: 160px;

      .data-count {
        margin-bottom: 40px;

        .data-ul {
          width: 990px;
          padding: 25px 83px 27px 83px;
        }

        .data-li-value {
          font-size: 35px;
          margin-bottom: 17px;
        }

        .data-li-name {
          font-size: 20px;
        }
      }

      .table-wrapper {
        width: 990px;

        .sort {
          border-radius: 8px;
          line-height: 49px;
          margin-bottom: 33px;
          padding: 0 15px 0 28px;

          .sort-name {
            font-size: 13px;
            width: 55px;
          }

          .sort-ul {
            li {
              font-size: 13px;
              padding: 0 24px;
            }
          }
        }

        .table {
          margin-bottom: 35px;
        }

        .table-title {
          margin-bottom: 31px;
          font-size: 20px;
          padding: 45px 0;
        }

        .table-title::after {
          width: 88px;
          height: 108px;
        }
      }

    }
  }
</style>